import {
  MARKETPLACE_LIST_ERROR,
  MARKETPLACE_LIST_SUCCESS,
  MARKETPLACE_LIST_REQUEST,
} from "./constants";

const initialState = {
  loading: false,
  data: [],
};

export default function marketplaceListReducer(state = initialState, action) {
  switch (action.type) {
    case MARKETPLACE_LIST_REQUEST:
      return { ...state, loading: true };
    case MARKETPLACE_LIST_SUCCESS:
      return {
        ...state,
        data: action.data,
        loading: false,
      };
    case MARKETPLACE_LIST_ERROR:
      return { ...state, loading: false };

    default:
      return state;
  }
}
